<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title" id="projectTitle">Adicionar String</h5>
  </div>
  <form [formGroup]="stringForm">
    <div class="modal-body">
      <div class="form-row">
        <div class="col-md-3">
          <div class="form-group">
            <label for="font">Qual a fonte?</label>
            <select class="custom-select" id="font" formControlName="font"
                [ngClass]="{ 'is-invalid': submitted && stringForm.get('font').hasError('required') }">
              <option *ngFor="let protocolSource of protocolFonts" [value]="protocolSource.id">{{ protocolSource.setting_protocol.font }}</option>
            </select>
            <small class="invalid-feedback" *ngIf="submitted && stringForm.get('font').hasError('required')">
              Fonte não foi informada
            </small>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label for="string_base">String *</label>
            <input type="text" formControlName="string_base" class="form-control" id="string_base"
              [ngClass]="{ 'is-invalid': submitted && stringForm.get('string_base').hasError('required') }"
              (ngModelChange) = "HiddenImportString()">
            <small class="invalid-feedback" *ngIf="submitted && stringForm.get('string_base').hasError('required')">
              String não foi informada
            </small>
          </div>
        </div>
        <div class="col-md-3" *ngIf = "showImportString">
          <div class="form-group">
            <button type="button" (click)="importBaseString()" class="btn btn-info btn-sm btn-str-base">
              Importar String Base
            </button>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col-md-4">
          <div class="form-group">
            <label for="ini_period">Período Início</label>
            <input type="number" min="0" class="form-control" id="ini_period" formControlName="ini_period"
                [ngClass]="{ 'is-invalid': submitted && stringForm.get('ini_period').hasError('required') }">
            <small class="invalid-feedback" *ngIf="submitted && stringForm.get('ini_period').hasError('required')">
              Período início não foi informado
            </small>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label for="end_period">Período Fim</label>
            <input type="number" min="0" class="form-control" id="end_period" formControlName="end_period"
                [ngClass]="{ 'is-invalid': submitted && stringForm.get('end_period').hasError('required') }">
            <small class="invalid-feedback" *ngIf="submitted && stringForm.get('end_period').hasError('required')">
              Período fim não foi informado
            </small>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label for="doc_types">Tipos de documento</label>
            <input type="text" class="form-control" id="doc_types" formControlName="doc_types"
                [ngClass]="{ 'is-invalid': submitted && stringForm.get('doc_types').hasError('required') }">
            <small class="invalid-feedback" *ngIf="submitted && stringForm.get('doc_types').hasError('required')">
              Período fim não foi informado
            </small>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col">
          <label for="crawlers">Indexadores</label>
          <!-- <tag-input
            formControlName="crawlers"
            theme="bootstrap"
            placeholder="Digite e tecle ENTER"
            secondaryPlaceholder="Digite e tecle ENTER"
            [ngClass]="{ 'is-invalid-tags': submitted && stringForm.get('crawlers').hasError('required') }"
          >
          </tag-input> -->
          <textarea
            rows="3"
            formControlName="crawlers"
            placeholder="Utilize ENTER para separar as opções..."
            class="form-control"
            [ngClass]="{ 'is-invalid-tags': submitted && stringForm.get('crawlers').hasError('required') }"
          ></textarea>
          <small style="color:#dc3545;" *ngIf="submitted && stringForm.get('crawlers').hasError('required')">
            Campo sinônimos é obrigatório
          </small>
        </div>
      </div>
      <div class="form-row">
        <div class="col">
          <input type="checkbox" formControlName="in_checklist" id="in_checklist" />
          &nbsp;<label for="in_checklist">Fazer parte da análise</label>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-link" (click)="activeModal.dismiss()">Voltar</button>
      <button type="submit" [attr.data-loader]="!submitted" (click)="save()" btnloader class="btn btn-primary">
        Salvar
      </button>
    </div>
  </form>
</div>
